// extracted by mini-css-extract-plugin
export default {"sticky-panel":"stickyPanel_sticky-panel__y-M4-"};